import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import Dashboard from "./pages/Dashboard";
import FleetManager from "./pages/FleetManager";
import BlogManager from "./pages/BlogManager";
import TranslationEditor from "./pages/TranslationEditor";
import UserManager from "./pages/UserManager";
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh"><CircularProgress /></Box>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/admin" replace />;
  return <AdminLayout>{children}</AdminLayout>;
};

const AdminApp = () => (
  <AuthProvider>
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route path="" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="fleet" element={<ProtectedRoute><FleetManager /></ProtectedRoute>} />
      <Route path="blog" element={<ProtectedRoute><BlogManager /></ProtectedRoute>} />
      <Route path="translations" element={<ProtectedRoute><TranslationEditor /></ProtectedRoute>} />
      <Route path="users" element={<ProtectedRoute adminOnly><UserManager /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  </AuthProvider>
);

export default AdminApp;
